// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__idEnA","title":"ClientCherryInfo_title__5Wywb","itemText":"ClientCherryInfo_itemText__1DCNB"};